import React from 'react'
import { Outlet } from 'react-router-dom'
import { Row, Col, Card } from 'reactstrap'
import DashboardNavBar from '../Home/DashboardNavBar'
import SideBar from '../Home/SideBar'
// import '../dashboard/Styles/Styles.css'
export default function AppIndex() {
  return (
    <div className='world'>
      <Row className="m-0 p-0">
        <Col md={12} className="m-0 p-0">
          <DashboardNavBar />
        </Col>
      </Row>
      <div className="p-3 mx-1">
        <Outlet />
      </div>
    </div>
  )
}
